// extracted by mini-css-extract-plugin
module.exports = {"sectorWithSticky":"_7a3fb80146--sectorWithSticky--le9YP","container":"_7a3fb80146--container--ObufB _7a3fb80146--sectorWithSticky--le9YP"};